<template>
  <div class="customer-follow fine-scroll-bar">
    <!-- 表单区域 -->
    <div class="entering">
      <div class="edit" v-if="isEdit">
        <div class="content">
          <div class="title"><i>*</i>跟进内容</div>
          <el-form>
            <el-form-item :error="textareaError">
              <el-input
                type="textarea"
                placeholder="请输入内容"
                resize="none"
                :rows="4"
                :maxlength="800"
                v-model="followContent"
                size="small"
                @blur="textareaRules"
              >
              </el-input>
            </el-form-item>
          </el-form>
          <Upload
            :acceptType="acceptType"
            :uploadHandling="false"
            :fileListArr="imgList"
            :totalNum="10"
            :paramsupload="paramsupload"
            :size="25"
            maxFiles="最多可上传10个文件"
            flieSize="单个文件最大不可超过25M"
            @changeFileList="changeFileList"
            :recordsFlag="true"
          ></Upload>
          <div class="selects">
            <div class="select">
              <div class="title">跟进方式</div>
              <el-select size="small" v-model="followType">
                <el-option
                  v-for="item in followTypeOptions"
                  :key="item.codeValue"
                  :value="item.codeValue"
                  :label="item.name"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select">
              <div class="title">相关联系人</div>
              <el-select
                clearable
                size="small"
                v-model="customerUserModel"
                :disabled="contact"
                filterable
              >
                <el-option
                  v-for="item in supplierCustomerUserVoList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.contactName"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="btns">
            <el-button size="small" @click="cancelEdit">取消</el-button>
            <el-button size="small" type="primary" :loading="saveLoading" @click="save"
              >保存</el-button
            >
          </div>
        </div>
      </div>
      <div class="read" v-else @click="handleEdit">
        <div>
          <i class="iconfont icon-icon-tianxie"></i>
          填写客户跟进情况
        </div>
      </div>
    </div>
    <!-- 跟进记录 -->
    <div class="record">
      <h3>跟进记录</h3>
      <!-- 选择项 -->
      <div class="selests" v-if="firstFlag">
        <div class="left">
          <el-select
            @change="wayOrKeywordChange"
            size="small"
            class="wayOrKeyword"
            v-model="wayOrKeyword"
          >
            <el-option :value="1" label="跟进方式"></el-option>
            <el-option :value="2" label="关键词"></el-option>
          </el-select>
        </div>
        <div class="right">
          <el-select
            v-if="wayOrKeyword === 1"
            size="small"
            v-model="searchData.followType"
            
            clearable
            @clear="getList()"
          >
            <el-option
              v-for="item in followTypeOptions"
              :key="item.codeValue"
              :value="item.codeValue"
              :label="item.name"
            >
            </el-option>
          </el-select>
          <el-input clearable v-else v-model="searchData.keyword" placeholder="请输入跟进内容"> </el-input>
          <el-button size="small" @click="getList()">
            <i class="iconfont icon-icon-fangdajing"></i>
          </el-button>
        </div>
      </div>
      <!-- 内容 -->
      <div class="content" v-loading="loading">
        <ul v-if="recordList.length">
          <li v-for="item in recordList" :key="item.id">
            <i
              v-if="
                tagColor(item.followType).text === 'Skype联系' ||
                tagColor(item.followType).text === 'WhatsApp联系'
              "
              class="iconfont no-context"
              :class="tagColor(item.followType).icon"
              :style="'color:' + tagColor(item.followType).color"
            >
            </i>
            <div
              v-else
              class="icon"
              :style="'backgroundColor:' + tagColor(item.followType).color"
            >
              <i class="iconfont" :class="tagColor(item.followType).icon"></i>
            </div>
            <h6>
              <span
                >{{ item.createTime | format('HH:mm') }} 周{{
                  item.createTime | weekFormat
                }}
                {{ item.createTime | format('DD/MM YYYY') }}</span
              >
              <div class="tag">
                <div
                  class="tag-item"
                  :style="{
                    color: tagColor(item.followType).color,
                    'background-color': `rgba(${
                      tagColor(item.followType).rgb
                    },0.1)`,
                  }"
                >
                  {{ tagColor(item.followType).text }}
                </div>
              </div>
            </h6>
            <div>
              <div class="name">{{ item.createUser | noText }}</div>
              <div
                class="text"
                v-if="item.followContent"
                v-html="strEnterReplace(item.followContent)"
              ></div>
              <div calss="images" v-if="item.attachs && item.attachs.length">
                <FileView
                  style="margin-top: 12px"
                  v-if="item.attachs && item.attachs.length"
                  :dataList="item.attachs"
                  :sensitive="false"
                  :isWorkOrder="true"
                ></FileView>
              </div>
              <div class="contactPerson" v-if="item.customerUser">
                <span>相关联系人:</span>
                <b>{{ item.customerUser }}</b>
              </div>
            </div>
          </li>
        </ul>
        <div class="noData" v-else>
          <img src="@/assets/image/common/noData.png" alt="" />
          <p>暂无数据</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Upload from './Upload'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import FileView from './FileView'
import {
  setCustomerFollow,
  getCustomerFollowList,
  getContactList,
} from '@/utils/api/customer'
import { getSingleDictByType } from '@/utils/api/common.js'
import { strEnterReplace } from '@/utils/common.js'
export default {
  components: {
    Upload,
    ElImageViewer,
    FileView,
  },
  props: {
    customerId: {
      type: Number,
      default: '',
    },
    supplierCustomerUserVoList: {
      default() {
        return []
      },
    },
    contact: {
      default: false,
      type: Boolean,
    },
    contactName: {
      default: '',
    },
    contactId: {
      default: '',
    },
  },
  computed: {
    customerUserModel: {
      get() {
        return this.contact ? this.customerUserName : this.customerUserId
      },
      set(val) {
        this[this.contact ? 'customerUserName' : 'customerUserId'] = val
      },
    },
  },
  watch: {
    // 客户详情才会触发
    customerId: {
      handler(newVal, oldVal) {
        if (this.contact) return
        this.followContent = ''
        this.imgList = []
        this.followType = 90
        this.customerUserId = ''
        this.isEdit = false
        this.wayOrKeyword = 1
        this.searchData = {
          followType: '',
          keyword: '',
        }
        this.firstFlag = false
        this.recordList = []
        this.getList(true)
      },
      immediate: true,
    },
    contactName: {
      handler(newVal) {
        this.customerUserName = newVal
      },
      immediate: true,
    },
    // 联系人详情才会触发
    contactId: {
      handler(newVal, oldVal) {
        if (!this.contact) return
        this.customerUserId = newVal
        this.followContent = ''
        this.imgList = []
        this.followType = 90
        this.isEdit = false
        this.wayOrKeyword = 1
        this.searchData = {
          followType: '',
          keyword: '',
        }
        this.firstFlag = false
        this.recordList = []
        this.getList(true)
      },
      immediate: true,
    },
  },
  data() {
    return {
      followContent: '',
      imgList: [],
      paramsupload: {
        source: 90,
        sourceType: 90,
        isCreateThumbnail: false,
        project: 'haizol-seamark-web-online',
        modelType: 5,
        isCreateThumbnail: false,
        picSizeType: 1,
      },
      isEdit: false,
      followTypeOptions: [],
      followType: 90,
      customerUserId: '',
      wayOrKeyword: 1,
      searchData: {
        followType: '',
        keyword: '',
      },
      recordList: [],
      firstFlag: false,
      loading: true,
      acceptType:
        '.slddrw, .sldprt,.sldasm,.prt, .eprt, .asm,.dxf,.dwg,.x_t,.igs,.iges,.step,.stp,.stl,.ipt, .iam,.idb,.doc, .docx,.xls,.xlsx,.ppt,.pptx,.zip,.rar,.7z,.pdf,.jpg,.gif,.jpeg,.bmp,.png, .txt,.csv,.tif,.3dm,.sat,.obj',
      textareaError: '',
      customerUserName: '',
      saveLoading: false,
    }
  },
  methods: {
    strEnterReplace,
    // 当附件上传发生变化时
    changeFileList(arr, flag) {
      this.imgList = arr
    },

    // 编辑
    handleEdit() {
      this.isEdit = true
    },

    // 保存提交跟进
    async save() {
      try {
        // 校验跟进内容是否为空
        if (!this.followContent.trim()) {
          return (this.textareaError = '跟进内容不能为空')
        }
        this.textareaError = ''

        // 校验是否有附件正在上传中
        const isProgress = this.imgList.some((ele) => {
          return ele.progress !== 100
        })
        if (isProgress) return this.$message.error('附件上传中，请勿提交')

        this.saveLoading = true

        const res = await setCustomerFollow({
          customerId: this.customerId,
          followContent: this.followContent,
          attachs: this.imgList.map((ele) => ele.hashCode),
          followType: this.followType,
          customerUser: this.customerUserId,
        })

        if (res.rspResult.bizCode === 200) {
          // 保存成功后，清空对应表单
          this.followContent = ''
          this.imgList = []
          this.followType = 90
          if (!this.contactId) this.customerUserId = ''
          this.isEdit = false

          // 重新获取列表和详情数据
          this.$emit('anewGetDetail')
        }
        this.saveLoading = false
      } catch (err) {
        console.error("❌ ~ file: index.vue:368 ~ save ~ err:", err)
        this.saveLoading = false
      }
    },

    async initData() {
      try {
        const res = await getSingleDictByType(
          'saas_supplier_customer_follow_type'
        )
        if (res.rspResult.bizCode === 200) {
          this.followTypeOptions = res.rspListData.list
        }
      } catch (err) {
        console.error("❌ ~ file: index.vue:381 ~ initData ~ err:", err)
      }
    },

    // 获取跟进记录
    // isFirst: 是否是首次加载
    async getList(isFirst) {
      this.recordList = []
      this.loading = true
      try {
        const { keyword, followType } = this.searchData
        const res = await getCustomerFollowList({
          customerId: this.customerId,
          followType:
            this.wayOrKeyword === 1 ? followType || undefined : undefined,
          keyword:
            this.wayOrKeyword === 2 ? keyword.trim() || undefined : undefined,

          // 如果是联系人详情，需要传联系人id
          customerUserId: this.contactId || undefined,
        })
        if (res.rspResult.bizCode === 200) {
          this.recordList = res.rspListData.list
          this.firstFlag =
            isFirst && !res.rspListData.list?.length ? false : true
        }
        this.loading = false
      } catch (err) {
        console.error("❌ ~ file: index.vue:409 ~ getList ~ err:", err)
        this.loading = false
      }
    },

    // 当跟进方式和关键词选择发生变化时触发
    wayOrKeywordChange() {
      this.searchData.keyword = ''
      this.searchData.followType = ''
    },

    // 标签颜色和文本值
    tagColor(code) {
      let color = ''
      let rgb = ''
      let icon = ''
      let text = ''
      switch (code) {
        case 10: // 电话沟通
          color = '#20B820'
          rgb = '32, 184, 32'
          icon = 'icon-icon-dianhua'
          text = '电话沟通'
          break
        case 20: // 邮件联系
          color = '#E6A23C'
          rgb = '230, 162, 60'
          icon = 'icon-icon-youjian'
          text = '邮件联系'
          break

        case 30: // WhatsApp联系
          color = '#20B820'
          rgb = '32, 184, 32'
          icon = 'icon-icon-whatsapp'
          text = 'WhatsApp联系'
          break
        case 40: // Skype联系
          color = '#00AFF0'
          rgb = '0, 175, 240'
          icon = 'icon-icon-skype'
          text = 'Skype联系'
          break
        case 50: // Wechat联系
          color = '#20B820'
          rgb = '32, 184, 32'
          icon = 'icon-icon-weixin'
          text = 'Wechat联系'
          break

        case 60: // 微信
          color = '#20B820'
          rgb = '32, 184, 32'
          icon = 'icon-icon-weixin'
          text = '微信联系'
          break
        case 70: // qq
          color = '#318CED'
          rgb = '49, 140, 237'
          icon = 'icon-icon-QQ'
          text = 'QQ联系'
          break
        case 80: // 见面拜访
          color = '#0BB976'
          rgb = '11, 185, 118'
          icon = 'icon-icon-xianxiabaifang'
          text = '见面拜访'
          break
        default: // 其他
          color = '#FF7F2A'
          rgb = '255, 127, 42'
          icon = 'icon-icon-qita'
          text = '其他'
          break
      }
      return {
        color,
        rgb,
        icon,
        text,
      }
    },

    // 取消编辑
    cancelEdit() {
      this.followContent = ''
      this.imgList = []
      this.followType = 90
      if (!this.contactId) this.customerUserId = ''
      this.textareaError = ''
      this.isEdit = false
    },

    textareaRules() {
      // 校验跟进内容是否为空
      if (!this.followContent.trim()) {
        return (this.textareaError = '跟进内容不能为空')
      }
      this.textareaError = ''
    },
  },
  created() {
    this.initData()
  },
}
</script>

<style lang="scss" src="./style/index.scss" scoped></style>
